export default __webpack_public_path__ + "static/RobbieBrender-2f47f8faa9d1bbe4f260562e4883b528.jpg";